/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Waiting_PaymentInputs */

const vi_pos_waiting_payment = /** @type {(inputs: Pos_Waiting_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ thanh toán...`)
};

/**

* @param {Pos_Waiting_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_waiting_payment = /** @type {((inputs?: Pos_Waiting_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Waiting_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_waiting_payment(inputs)
});